import axios from 'axios';

export default {
  props: {
    coverType: {
      default: { name: '', coverTypeId: 0, chargeableBenefits: [] },
      type: Object,
    },
  },
  data() {
    return {
      policyDetails: {},
    };
  },
  methods: {
    fetchPolicyDetails(policyNumber) {
      const payload = { policyNo: policyNumber };
      axios.post('/motor/api/policy/detail',
        payload).then((response) => {
        this.policyDetails = response.data;
        this.coverType.name = response.data.data.productName;
        this.coverType.productCode = response.data.productId;
        if (this.coverType.name === 'Comprehensive') {
          this.coverType.coverTypeId = 120;
        } else if (this.coverType.name === 'Third Party') {
          this.coverType.coverTypeId = 121;
        } else {
          this.coverType.coverTypeId = 0;
        }
        localStorage.setItem('premium', response.data.data.premium);
        localStorage.setItem('totalPremium', response.data.data.totalPremium);
      });
    },
    initCoverType(policyNumber) {
      this.fetchPolicyDetails(policyNumber);
      axios.get('/motor/api/premium/fixedBenefitRates')
        .then((response) => {
          this.coverType.chargeableBenefits = response.data.data;
        });
    },
    // installments() {
    //   return this.quote?.instalments || [];
    // },
  },
};
